import React, { useMemo } from "react";
import { Box, Button } from "@tiny/components";
import { PredefinedSegmentsProvider } from "./PredefinedSegments.context";
import { SegmentsSectionProps } from "./PredefinedSegments.types";
import { SectionHeader } from "./SectionHeader";
import { SegmentCards } from "./SegmentCards";
import { useTinyHost } from "@tiny/host-contract";
import { AppSumoPlanCodes, PlanCodes } from "../../constants";

export function SegmentLibrarySection({
  segments,
  selected,
  selectionDisabled,
  onSegmentSelect,
}: SegmentsSectionProps) {
  const { capabilities, upsell } = useTinyHost();
  const planCode = capabilities.planCode;
  const isEnabled =
    planCode &&
    (
      [
        PlanCodes.Pro,
        AppSumoPlanCodes.LicenceTier1,
        AppSumoPlanCodes.LicenceTier2,
        AppSumoPlanCodes.LicenceTier3,
        AppSumoPlanCodes.LicenceTier4,
      ] as string[]
    ).includes(planCode);
  const isDisabled = !isEnabled;
  const context = useMemo(
    () => ({
      isDisabled: isDisabled,
      isRecommended: false,
    }),
    [isDisabled]
  );
  const showPlanSelectionDialog = () => upsell.showPlanSelection?.();

  return (
    <PredefinedSegmentsProvider value={context}>
      <Box
        id="segmentsLibrarySection"
        mt={{ xs: 7, md: 6 }}
        display="flex"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <SectionHeader
          id="segmentsLibrarySection_Header"
          title="Segment Library"
          subtitle="We have pre-built the best-in-class segments for your use. "
        />
        {isDisabled && (
          <Box>
            <Button variant="outlined" onClick={showPlanSelectionDialog}>
              Upgrade
            </Button>
          </Box>
        )}
        <SegmentCards
          id="segmentsLibrarySection_Content"
          cards={segments}
          selected={selected}
          onSegmentSelect={onSegmentSelect}
          selectionDisabled={selectionDisabled}
        />
      </Box>
    </PredefinedSegmentsProvider>
  );
}
